import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: a = 16, useVw: t, useRem: l, color: o, withColor: c, removeClassName: n, disableSSR: m, style: r, ...p }) => {
  const x = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-anquanrenzheng", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "24px-å®å¨è®¤è¯"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: n ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.617 8.302a.836.836 0 0 0-.837.83v2.08a2.787 2.787 0 0 1-.822 5.448 2.785 2.785 0 0 1-.778-5.461V9.13c0-1.346 1.1-2.43 2.437-2.43a.8.8 0 0 1 0 1.6Zm-1.659 6.758a1.186 1.186 0 1 0 0-2.371 1.186 1.186 0 0 0 0 2.37Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.051 1.31a2.8 2.8 0 0 0-2.094 0L3.954 4.13A2.8 2.8 0 0 0 2.2 6.728v3.036a13.962 13.962 0 0 0 7.912 12.583 4.367 4.367 0 0 0 3.779 0A13.96 13.96 0 0 0 21.8 9.767v-3.04a2.8 2.8 0 0 0-1.753-2.596L13.051 1.31Zm-1.496 1.483a1.2 1.2 0 0 1 .898 0l6.996 2.822a1.2 1.2 0 0 1 .751 1.113v3.039a12.36 12.36 0 0 1-7.002 11.137 2.767 2.767 0 0 1-2.394 0A12.362 12.362 0 0 1 3.8 9.764V6.728c0-.49.297-.93.752-1.113l7.003-2.822Z"
        }
      )
    )
  )));
}, s = g;
export {
  s as default
};
